import {
    SET_CURRENT_EVALUATION,
    SET_EVALUATION_DATA,
    SET_ANALYSIS_DATA,
    SET_EVALUATION_LOADING,
    START_TIME,
    SET_ANSWER,
    CLEAR_ANSWER,
    SET_EVALUATION_TAB_INDEX
} from '../actions/evaluation';

export function evaluation(state = {datas:[],page:-2}, action) {
    if (action.type === SET_EVALUATION_DATA) {
        return {
            ...state,
            // page: action.page,
            // pageSize: action.pageSize,
            // total: action.data.count,
            datas: action.evaluation.results[0],
        }
    } else if (action.type === SET_EVALUATION_LOADING) {
        return {
            ...state,
            isLoading: action.loading,
            tabIndex: state.tabIndex ? state.tabIndex : 0,
        }
    } else if (action.type === SET_EVALUATION_TAB_INDEX) {
        return {
            ...state,
            tabIndex: action.tabIndex
        }
    } else if (action.type === START_TIME) {
        return {
            ...state,
        }
    } else if(action.type === SET_ANALYSIS_DATA){
        return{
            ...state,
            datas: action.evaluation.mistakes,
        }
    }
    return state;
}

export function answer(state = {answers:{}}, action) {
    console.log(action,'接收')
    if ((action.type === SET_ANSWER)) {
        const {index, answer} = action;
        const currentAnswer = {};
        currentAnswer[index] = answer;
        return {
            answers: {...state.answers,...currentAnswer}
        }
    } else if ((action.type === CLEAR_ANSWER)) {
        return {
            answers:{}
        }
    }

    return state;
}

export function currentEvaluation(state = {page:-2}, action) {
    if ((action.type === SET_CURRENT_EVALUATION)) {
        return {
            ...action.evaluation
        }
    }
    return state;
}

export function setCurrentEvaluation(evaluation) {
    return {type: SET_CURRENT_EVALUATION, evaluation};
}